// extracted by mini-css-extract-plugin
export default {"breadcrumb":"TOwHfhKsmwSANd9aFvXXY"};